<template>
  <div class="games-list-skeleton" :class="{ '--live': isLive }">
    <div v-for="game in countValue" :key="game" class="games-list-skeleton-item base-border-radius">
      <div class="games-list-skeleton__bg" :style="{ backgroundImage: `url('img/default-game.svg')` }"></div>
      <ol-skeleton class="games-list-skeleton__name" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { OlSkeleton } from '@gamesite/olimp-core'

const props = defineProps({
  count: {
    type: Number,
    default: 24,
  },
  logoGroup: {
    type: String,
    default: '',
  },
})

const countValue = computed(() => props.count || 24)
const isLive = computed(() => props.logoGroup === 'online')
</script>
